import React, { useState, useEffect } from "react";
import { GoInfo, GoX } from "react-icons/go";
import { AiOutlineDelete } from "react-icons/ai";
import { message, Select, Popconfirm } from "antd";
import { NavLink } from "react-router-dom/cjs/react-router-dom.min";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";
import { FilterOutlined } from "@ant-design/icons";
import "./style/assistanceTable.css";
import server, { endpoints } from "../../../utils/server";
import ModalGraphics from "./modalGraphics";
import Arrow from "../../../resources/left-arrow.png";
import ArrowRight from "../../../resources/right-arrow.png";
import useWindowDimensions from "../../../utils/useWindowDimensions";
import { useHistory } from "react-router-dom";

const AssistanceEvents = ({ idCycle }) => {
  const [tableData, setTableData] = useState([{}]);
  // Esto se usara para copiar el data de tabledata cada que se actualice y aplicar
  // los filtros sin que se pierda la informacion
  const [tableDataCopy, setTableDataCopy] = useState([{}]);
  const [searchField, setSearchField] = useState("");
  const [usersData, setUsersData] = useState([{}]);
  const [scoreData, setScoreData] = useState("");
  const [eventTitle, setEventTitle] = useState("");
  const [columnsData, setColumnsData] = useState([{}]);
  const [fieldsName, setFieldsName] = useState([
    "first_name",
    "last_name",
    "up_id",
    "team_name",
  ]);

  const [columnSelected, setColumnSelected] = useState("");
  const [teamsInCycle, setTeams] = useState([{}]);
  const { width, height } = useWindowDimensions();
  const [totalScore, setTotalScore] = useState(0);
  const [showModal, setShowModal] = useState(false);
  const [showFilter, setShowFilter] = useState(false);
  const [filterPosition, setFilterPosition] = useState({});
  const [selectedEvent, setSelectedEvent] = useState();
  const [selectedEventId, setSelectedEventId] = useState();
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;
  const totalPages = Math.ceil(tableDataCopy.length / itemsPerPage);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  let startPage = currentPage > 1 ? currentPage - 1 : 1;
  let endPage = currentPage + 1 <= totalPages ? currentPage + 1 : totalPages;
  const currentItems = tableDataCopy.slice(indexOfFirstItem, indexOfLastItem);

  const pageNumbers = [];
  for (let i = startPage; i <= endPage; i++) {
    pageNumbers.push(i);
  }
  useEffect(() => {
    getDepartmentEventPerCycle();
    getAllUsersInCycleWithTeams();
    getUserDepartmentEventPerCycle();
    getTeamsInCycle(idCycle);
  }, []);

  useEffect(() => {
    setTableDataCopy(tableData);
  }, [tableData]);

  const getAllUsersInCycleWithTeams = async () => {
    const res = await server(
      endpoints.getAllUsersInCycleWithTeams.route,
      endpoints.getAllUsersInCycleWithTeams.method,
      { id_cycle: idCycle }
    );

    const { error_message, data: tableData } = res;
    if (res.error_message) {
      message.error(res.error_message);
    } else {
      setTableData(tableData);
    }
  };

  const history = useHistory();

  const getTeamsInCycle = async (idCycle) => {
    try {
      const res = await server(
        endpoints.getTeamsInCycle.route,
        endpoints.getTeamsInCycle.method,
        { id_cycle: idCycle }
      );

      if (res.error_message) {
        message.error(res.error_message);
        if (res.error_message === "Por favor actualice su contraseña") {
          history.push("/changePassword");
        }
        return;
      }

      const teamsInCycle = res.data;
      setTeams(teamsInCycle);
    } catch (err) {
      console.error("Error fetching teams in cycle:", err);
    }
  };

  const getUserDepartmentEventPerCycle = async () => {
    const res = await server(
      endpoints.getUserDepartmentEventPerCycle.route,
      endpoints.getUserDepartmentEventPerCycle.method,
      { id_cycle: idCycle }
    );

    const { error_message, data: users } = res;
    if (res.error_message) {
      message.error(res.error_message);
    } else {
      setUsersData(users);
    }
  };

  const deleteDepartmentEventPerCycle = async (id_event) => {
    const res = await server(
      endpoints.deleteDepartmentEventPerCycle.route,
      endpoints.deleteDepartmentEventPerCycle.method,
      { id_department_event: id_event }
    );

    if (res.error_message) {
      message.error(res.error_message);
    } else {
      message.success(res.message);
      getDepartmentEventPerCycle();
      getUserDepartmentEventPerCycle();
    }
  };

  const getDepartmentEventPerCycle = async () => {
    setTotalScore(0);
    const res = await server(
      endpoints.getDepartmentEventPerCycle.route,
      endpoints.getDepartmentEventPerCycle.method,
      { id_cycle: idCycle }
    );

    const { error_message, data: columns } = res;
    let total = 0;
    columns.map((i, index) => {
      total += i.score;
    });
    setTotalScore(total);
    if (res.error_message) {
      message.error(res.error_message);
    } else {
      setColumnsData(
        [
          {
            name: "Nombre",
          },
          {
            name: "Apellido",
          },
          {
            name: "ID",
          },
          {
            name: "Equipo",
          },
        ].concat(columns.concat([{ name: "Total" }]))
      );
    }
  };

  const insertDepartmentEventPerCycle = async () => {
    const res = await server(
      endpoints.insertDepartmentEventPerCycle.route,
      endpoints.insertDepartmentEventPerCycle.method,
      { id_cycle: idCycle },
      {
        name: "Nuevo Evento",
        date: getCurrentDate(),
        score: "0",
      }
    );

    if (res.error_message) {
      message.error(res.error_message);
    } else {
      getUserDepartmentEventPerCycle();
      getDepartmentEventPerCycle();
    }
  };

  const updateUserDepartmentEventPerCycle = async (id_user, id_event) => {
    const res = await server(
      endpoints.updateUserDepartmentEventPerCycle.route,
      endpoints.updateUserDepartmentEventPerCycle.method,
      {
        id_department_event: id_event,
        id_department_event_per_cycle: id_event,
        id_user: id_user,
      }
    );

    const { error_message, data: columns } = res;
    if (res.error_message) {
      message.error(res.error_message);
    } else {
      getUserDepartmentEventPerCycle();
    }
  };

  const updateAllUserAttendance = async (id_event) => {
    const res = await server(
      endpoints.updateAllUserAttendance.route,
      endpoints.updateAllUserAttendance.method,
      {
        id_cycle: idCycle,
        id_department_event_per_cycle: id_event,
        id_department_event: id_event,
      }
    );
    if (res.error_message) {
      message.error(res.error_message);
    } else {
      message.success(res.message);
      getUserDepartmentEventPerCycle();
    }
  };

  const updateEventPerCycleScore = async (id_event) => {
    const body = {
      scoreData,
    };
    const res = await server(
      endpoints.updateEventPerCycleScore.route,
      endpoints.updateEventPerCycleScore.method,
      {
        id_department_event: id_event,
        id_department_event_per_cycle: id_event,
      },
      { score: scoreData }
    );

    if (res.error_message) {
      message.error(res.error_message);
    } else {
      message.success(res.message);
      getUserDepartmentEventPerCycle();
    }
  };

  const updateDepartmentEventPerCycle = async (
    id_event,
    eventDate,
    eventScore
  ) => {
    const res = await server(
      endpoints.updateDepartmentEventPerCycle.route,
      endpoints.updateDepartmentEventPerCycle.method,
      {
        id_department_event: id_event,
        id_department_event_per_cycle: id_event,
      },
      {
        id_cycle: idCycle,
        name: eventTitle,
        date: eventDate,
        score: eventScore,
      }
    );

    if (res.error_message) {
      message.error(res.error_message);
    } else {
      message.success(res.message);
      setEventTitle("");
      getUserDepartmentEventPerCycle();
    }
  };

  const getCurrentDate = (separator = "-") => {
    let newDate = new Date();
    let date = newDate.getDate();
    let month = newDate.getMonth() + 1;
    let year = newDate.getFullYear();

    return `${year}${separator}${
      month < 10 ? `0${month}` : `${month}`
    }${separator}${date}`;
  };

  const handleCheckboxChange = (id_user, id_event) => {
    updateUserDepartmentEventPerCycle(id_user, id_event);
  };

  const handleAllChecked = (e, id_event) => {
    tableData.map((item) => {
      if (checkAssistance(item, id_event) != e.target.checked) {
        updateUserDepartmentEventPerCycle(item.id, id_event);
      }
    });

    getUserDepartmentEventPerCycle();
  };

  const checkAssistance = (user, eventId) => {
    const newUser = usersData?.find((e) => e.id_user === user.id);
    const event = newUser?.event_attendance?.find(
      (e) => e.id_event_per_cycle === eventId
    );

    return event?.attendance === 1;
  };

  const getUserScore = (user) => {
    const newUser = usersData?.find((e) => e.id_user === user.id);
    const score = newUser?.attendance_score;

    return score;
  };

  const handlePrevPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  const handleNextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  const handlePageClick = (page) => {
    setCurrentPage(page);
  };

  const handleKeyDown = (event, id_event, date, score, usingCase) => {
    if (event.key === "Enter") {
      if (usingCase == "score") {
        updateEventPerCycleScore(id_event);
      } else if (usingCase == "title") {
        updateDepartmentEventPerCycle(id_event, date, score);
      }
    }
  };

  const handleInputBlur = (id_event) => {
    updateEventPerCycleScore(id_event);
  };

  const handleChangeTitle = (e, id) => {
    const newValue = e.target.value;
    setColumnsData((prev) =>
      prev.map((col) => (col.id === id ? { ...col, name: newValue } : col))
    );
    setEventTitle(e.target.value);
  };

  const handleChangeScore = (event) => {
    setScoreData(event.target.value);
  };

  const handleSearch = (value) => {
    if (value == "") {
      setTableDataCopy(tableData);
      return;
    }
    setTableDataCopy(
      tableData.filter((data) => {
        if (isNaN(data[searchField])) {
          return data[searchField].toLowerCase().includes(value);
        } else {
          return data[searchField].toString().includes(value);
        }
      })
    );
  };

  return (
    <div className="assistanceEvents-container">
      {showModal ? (
        <div className="graphicsModal">
          <GoX
            className="assistanceEvents-closeModal"
            onClick={() => {
              setShowModal(!showModal);
            }}
          />
          <ModalGraphics
            idCycle={idCycle}
            eventName={selectedEvent}
            eventId={selectedEventId}
          ></ModalGraphics>
        </div>
      ) : null}
      <h2>Asistencia Eventos</h2>
      <div className="assistanceEvents-button-container">
        <button
          onClick={() => {
            insertDepartmentEventPerCycle();
          }}
        >
          Agregar evento
        </button>
      </div>
      <div className="assistanceEvents-table-container">
        <table className="assistanceEvents-table">
          <thead>
            <tr>
              {columnsData.map((i, index) => {
                return (
                  <th
                    className={
                      index <= 1
                        ? `assistanceEvents-col-header-${index + 1}`
                        : "assistanceEvents-col-header"
                    }
                  >
                    <div className="assistanceEvents-col-header-wrapper">
                      <div
                        className={
                          index <= 1
                            ? `assistanceEvents-col-Header-${index + 1}`
                            : "assistanceEvents-Header"
                        }
                      >
                        <div>
                          {index > 3 && i.name != "Total" ? (
                            <>
                              <input
                                className="assistanceEvents-events-Titles"
                                type="text"
                                value={i.name}
                                onChange={(e) => handleChangeTitle(e, i.id)}
                                onKeyDown={(e) => {
                                  handleKeyDown(
                                    e,
                                    i.id,
                                    i.date,
                                    i.score,
                                    "title"
                                  );
                                }}
                                onBlur={() => {
                                  updateDepartmentEventPerCycle(
                                    i.id,
                                    i.date,
                                    i.score
                                  );
                                }}
                              ></input>
                              <Popconfirm
                                title={"Borrar Evento"}
                                onConfirm={() => {
                                    deleteDepartmentEventPerCycle(i.id);
                                  }}
                                okText={"Eliminar"}
                                cancelText={"Cancelar"}
                              >
                                <AiOutlineDelete
                                  style={{ cursor: "pointer" }}
                                ></AiOutlineDelete>
                              </Popconfirm>
                            </>
                          ) : (
                            i.name
                          )}
                          {index > 3 && i.name != "Total" ? (
                            <GoInfo
                              className="assistanceEvents-InfoIcon"
                              onClick={() => {
                                setSelectedEvent(i.name);
                                setSelectedEventId(i.id);
                                setShowModal(!showModal);
                              }}
                            />
                          ) : null}
                        </div>
                        {index > 3 && i.name != "Total" ? (
                          <div>
                            <input
                              type="checkbox"
                              onClick={(e) => {
                                updateAllUserAttendance(i.id);
                              }}
                            ></input>
                          </div>
                        ) : null}
                      </div>

                      {index <= 3 && (
                        <FilterOutlined
                          className="assistanceEvents-col-filterIcon"
                          onClick={(event) => {
                            const ev = { X: -32, Y: 50 };
                            setColumnSelected(columnsData[index].name);

                            if (showFilter) {
                              setShowFilter("closing");
                              setTimeout(() => {
                                setShowFilter(false);
                                setShowFilter(true);
                                setFilterPosition({
                                  left:
                                    (width < 700 ? ev.X : ev.X + 20) >=
                                    width - 200
                                      ? width - 250
                                      : width < 700
                                      ? ev.X
                                      : ev.X + 20,
                                  top: ev.Y,
                                });
                              }, 380);
                            } else {
                              setShowFilter(true);
                              setFilterPosition({
                                left:
                                  (width < 700 ? ev.X : ev.X + 20) >=
                                  width - 200
                                    ? width - 250
                                    : width < 700
                                    ? ev.X
                                    : ev.X + 20,
                                top: ev.Y,
                              });
                            }
                            setSearchField(fieldsName[index]);
                          }}
                        />
                      )}

                      {showFilter != false &&
                      columnsData[index].name == columnSelected ? (
                        <div
                          style={filterPosition}
                          className={`assistanceEvents-col-filterModal ${
                            showFilter === "closing" ? "close" : "open"
                          }`}
                        >
                          <div className="assistanceEvents-col-filterModal-header">
                            Filtrar campo:
                          </div>

                          {columnSelected != "Equipo" ? (
                            <input
                              type="search"
                              className="assistanceEvents-col-filterModal-input"
                              name="assistanceEvents-col-filterModal_search_field"
                              placeholder="Introduce un texto..."
                              onChange={(e) =>
                                handleSearch(
                                  e.target.value.trim().toLowerCase()
                                )
                              }
                            />
                          ) : (
                            <select
                              className="assistanceEvents-col-filterModal-select"
                              onChange={(e) => {
                                handleSearch(
                                  e.target.value.trim().toLowerCase()
                                );
                              }}
                            >
                              {teamsInCycle.map((item, index) => {
                                return (
                                  <option key={index} value={item.name}>
                                    {item.name}
                                  </option>
                                );
                              })}
                            </select>
                          )}

                          <div className="assistanceEvents-col-filterModal-containerBtns">
                            <button
                              onClick={() => {
                                setShowFilter("closing");
                                setTimeout(() => {
                                  setShowFilter(false);
                                }, 380);
                              }}
                              className="assistanceEvents-col-filterModal-closeBtn"
                            >
                              Ok
                            </button>
                            <button
                              onClick={() => {
                                handleSearch("");
                                setShowFilter("closing");
                                setTimeout(() => {
                                  setShowFilter(false);
                                }, 380);
                              }}
                              className="assistanceEvents-col-filterModal-clearBtn"
                            >
                              Limpiar
                            </button>
                          </div>
                        </div>
                      ) : null}
                    </div>
                    {/*<button onClick={() => handleSort('id_answering')} className="filter-button">⇅</button>*/}
                  </th>
                );
              })}
            </tr>
          </thead>
          <tbody>
            <tr>
              {/*
                El primer registro de la tabla le da el espacio a los registros
                de verse mejor.
              */}
              {columnsData.map((item, index) => {
                if (
                  item.name != "Nombre" &&
                  item.name != "Apellido" &&
                  item.name != "ID" &&
                  item.name != "Equipo" &&
                  item.name != "Total"
                ) {
                  return (
                    <td>
                      <input
                        type="text"
                        style={{ textAlign: "center" }}
                        onChange={handleChangeScore}
                        onKeyDown={(e) => {
                          handleKeyDown(e, item.id, null, null, "score");
                        }}
                        onBlur={() => {
                          handleInputBlur(item.id);
                        }}
                        defaultValue={item.score}
                      ></input>
                    </td>
                  );
                } else {
                  return item.name == "ID" || item.name == "Equipo" ? (
                    <td className={`assistanceEvents-Column`}></td>
                  ) : (
                    <td className={`assistanceEvents-col-${index + 1}`}></td>
                  );
                }
              })}
            </tr>
            {/*
              Aqui comienza el verdadero despliegue de los datos de los asistentes.
            */}
            {currentItems.map((item, index) => (
              <tr key={index}>
                <td className={`assistanceEvents-col-1`}>{item.first_name}</td>
                <td className={`assistanceEvents-col-2`}>{item.last_name}</td>
                <td className={`assistanceEvents-Column`}>{item.up_id}</td>
                <td className={`assistanceEvents-Column`}>
                  {item.team_name != null ? item.team_name : "N/A"}
                </td>
                {columnsData.map((column, ind) => (
                  <>
                    {column.name != "Nombre" &&
                    column.name != "Apellido" &&
                    column.name != "ID" &&
                    column.name != "Equipo" ? (
                      column.name == "Total" ? (
                        <td
                          className={
                            getUserScore(item) / totalScore > 0.9
                              ? "assistanceEvents-Column-green"
                              : getUserScore(item) / totalScore > 0.75
                              ? "assistanceEvents-Column-yellow"
                              : "assistanceEvents-Column-red"
                          }
                        >
                          {getUserScore(item) != 0 ? getUserScore(item) : 0}
                        </td>
                      ) : (
                        <td className={"assistanceEvents-Column"}>
                          <input
                            type="checkbox"
                            checked={checkAssistance(item, column.id)}
                            onClick={() => {
                              handleCheckboxChange(item.id, column.id);
                            }}
                          ></input>
                        </td>
                      )
                    ) : null}
                  </>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div className="Pagination">
        <button onClick={handlePrevPage} disabled={currentPage === 1}>
          <img src={Arrow} alt="Previous" />
        </button>
        {pageNumbers.map((number) => (
          <button
            key={number}
            onClick={() => handlePageClick(number)}
            className={currentPage === number ? "active" : ""}
          >
            {number}
          </button>
        ))}
        <button onClick={handleNextPage} disabled={currentPage === totalPages}>
          <img src={ArrowRight} alt="Next" />
        </button>
      </div>
    </div>
  );
};

export default AssistanceEvents;
